import {useEffect, useState, useCallback} from 'react'
import {UserV3} from '@/features/authentication/types.ts'
// import {Message} from '@/features/chat/chat.model'
import {envVars} from '@/envVars'
// import {eventManager} from '../helpers'
// import {SSEEventType} from '../types'

const useSSEConnection = (user?: Partial<UserV3>, loggedIn?: boolean, isRepresentative?: boolean) => {
    // We will need to get correct data here from useQuery
    // const {data: channels} = useGetChannels(enabled: location.pathname === '/message-center')
    // const {data: notifications} = useGetNotifications() etc.

    console.log('useSSEConnection', isRepresentative)
    const [eventSource, setEventSource] = useState<EventSource | null>(null)

    const disconnect = useCallback(() => {
        if (eventSource) {
            eventSource.close()
            setEventSource(null)
        }
    }, [eventSource])

    const connect = useCallback(() => {
        const token = localStorage.getItem('bearer_access_token_v2')
        if (!token) return
        disconnect() // To be sure that we don't connected to SEE
        const connectionEndpoint = `${envVars.VITE_API_V3_ENDPOINT}/sse?bearerToken=${token}` // our SSE endpoint
        const sse = new EventSource(connectionEndpoint, {
            withCredentials: true
        })
        sse.onopen = () => {
            console.log('SSE connection opened')
        }

        sse.onerror = err => {
            console.error('SSE error:', err)
            const error = new Error('Connection lost')
            throw error
        }

        setEventSource(sse)
    }, [])

    useEffect(() => {
        if (user) {
            connect()
            // Here should be endpoint to get total unread message count
        } else if (!loggedIn) {
            disconnect()
        }
    }, [user, loggedIn])

    useEffect(() => {
        window.addEventListener('beforeunload', disconnect)
        return () => {
            disconnect()
        }
    }, [])

    return {
        isSSELoading: false,
        eventSource
    }
}

export default useSSEConnection
